import React from "react"
import { Dropdown } from "react-bootstrap"

// Redux
import { useDispatch, useSelector } from "react-redux"

// users
import { Link } from "react-router-dom"
import { FiUser, FiLogOut } from "react-icons/fi"

import user4 from "assets/img/avatar.jpg"
import {signOutRequest} from 'modules/Public/SignIn/store/slice';

import RouteConst from 'modules/routes'

const ProfileMenu = () => {
  // Declare a new state variable, which we'll call "menu"
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth)
  const username = user.username

  const handleSignOut = () => {
    // signOut()
    console.log('LOGOUT>>>')
    dispatch(signOutRequest())
  };

  return (
    <React.Fragment>
      <Dropdown
        className="d-inline-block header-main"
      >
        <Dropdown.Toggle
          className="btn header-item waves-effect"
          id="page-header-user-dropdown"
          tag="button"
        >
          <img
            className="rounded-circle header-profile-user"
            src={user4}
            alt="WestBay"
          />
          <span className="d-none d-xl-inline-block ms-1 fw-medium font-size-15">{username}</span>{" "}
          <i className="uil-angle-down d-none d-xl-inline-block font-size-15"></i>
        </Dropdown.Toggle>  
        <Dropdown.Menu className="dropdown-menu-end">

          <Link to={RouteConst.profile.profile} className="dropdown-item">
            {/* <i className="uil uil-user-circle font-size-18 align-middle text-muted me-1"></i> */}
            <FiUser /> Profile
          </Link>

          <Dropdown.Item onClick={handleSignOut}>
            <span className="text-danger">
              <FiLogOut /> Logout
            </span>
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </React.Fragment>
  )
}

export default ProfileMenu
